module.exports = __webpack_public_path__ + "img/motor_no63.a39a55af.jpg";